var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD28SocialYoutube = function SvgD28SocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d-28-social-youtube_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.152941 0 0 0 0 0.149020 0 0 0 0 0.164706 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFF3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d-28-social-youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.745 9.465c-.606-.721-1.726-1.015-3.864-1.015h-7.762c-2.187 0-3.326.313-3.93 1.08-.589.749-.589 1.851-.589 3.377v2.909c0 2.956.699 4.457 4.519 4.457h7.762c1.854 0 2.882-.26 3.546-.896.682-.652.973-1.717.973-3.561v-2.909c0-1.61-.046-2.718-.655-3.442zm-4.926 5.382-4.283 2.169a.675.675 0 0 1-.646-.02.634.634 0 0 1-.318-.546v-4.323c0-.223.12-.43.317-.546a.677.677 0 0 1 .645-.02l4.283 2.154c.218.11.355.328.355.566a.636.636 0 0 1-.353.566z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
};
export default SvgD28SocialYoutube;